// import { getLogger } from 'utils/logger';
import { REDUCER_KEY } from './reducer';
// const log = getLogger('data/rules/selector.js');

export const getRulesStore = (state) => state[REDUCER_KEY];
export const getLastSyncDate = (state: any) => getRulesStore(state).lastSyncDate;

export const getRulesById = (state) => {
  const newState = getRulesStore(state);
  
  return newState.resourcesById
    .sort((a, b) => a.renamePayeeTo.localeCompare(b.renamePayeeTo));
};

export function getRuleById(state, id) {
  if (state.resourcesById) {
    return state.resourcesById.get(id) || null;
  }
  return null;
}

